module.exports = __webpack_public_path__ + "static/Macbook-39e17a2de7b775dcca9ce4646b1c9158.png";